import SignUpHeader from "@/Components/Common/Auth/Components/SignUpHeader";
import SignUpComponent from "@/Components/Common/Auth/SigunUp";
import React, { useState } from "react";

const SignUp = () => {
  const [step, setStep] = useState(1);

  return (
    <div className="w-full h-screen flex items-center justify-start flex-col">
      <SignUpHeader step={step} setStep={setStep} />
      <SignUpComponent step={step} setStep={setStep} />
    </div>
  );
};

export default SignUp;
